<template>
    <b-card class="shadow mb-3 p-2">
        <b-row>
            <b-col>

                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-grow-1"><span class="h2">{{ title }}</span></div>

                    <div class="d-flex flex-grow-1 mb-3">
                        <div class="d-flex justify-content-center flex-grow-0 flex-wrap p-2">
                            <b-form-radio v-model="breakdownType" @change="onBreakdownTypeChange" name="event-breakdown-types" value="1" class="mr-4">По времени</b-form-radio>
                            <b-form-radio v-if="canSelectMunicipality()" v-model="breakdownType" @change="onBreakdownTypeChange" name="event-breakdown-types" value="2" class="mr-4">По муниципалитетам</b-form-radio>
                            <b-form-radio v-if="canSelectContractor()" v-model="breakdownType" @change="onBreakdownTypeChange" name="event-breakdown-types" value="3" class="">По исполнителям</b-form-radio>
                        </div>
                    </div>

                    <div class="col-xs-12">
                            <transition name="fade" mode="out-in">
                                <div v-if="chartDataInitialized && !fetchError">
                                    <EventStatisticsLine :chart-data="chartData" is-legend-visible="true" class="mb-4" style="max-width: 100%; height: 500px"/>
                                    <offscreen-chart :title="title">
                                        <template #subtitle>
                                            <span>{{ getOffscreenSubtitle() }}</span>
                                        </template>
                                        <template #chart>
                                           <EventStatisticsLine :chart-data="chartData" is-legend-visible="true" class="mb-4" style="width: 900px; height: 600px"/>
                                        </template>
                                    </offscreen-chart>
                                    <StatisticsTable :data="chartData" :pdf-visible="true" @on-value-clicked="onTableValueClicked"/>
                                </div>
                                <div v-else-if="!chartDataInitialized && !fetchError" class="d-flex w-100 align-items-center justify-content-center" style="max-width: 100%; height: 500px">
                                    <b-spinner variant="info"/>
                                </div>
                                <div v-else class="d-flex w-100 align-items-center justify-content-center" style="max-width: 100%; height: 500px">
                                    <div class="d-flex flex-column justify-content-center align-items-center">
                                        <div class="d-flex mb-3">
                                            <span ><b-icon icon="exclamation-triangle" variant="danger" class="mr-2"/></span>
                                            <span class="text-danger">Не удалось загрузить данные</span>
                                        </div>
                                        <div>
                                            <b-button variant=""
                                                    class="flex-grow-0 d-flex align-items-center flex-nowrap mb-3 mb-lg-0"
                                                    @click="fetch()">
                                                <b-icon icon="arrow-repeat" class="mr-2"/>
                                                <span>Попробовать ещё</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>

import EventStatisticsBar from "@/pages/Statistics/EventStatisticsBar";
import SingleSelect from "@/components/Select/SingleSelect.vue";
import {EventKind} from "@/pages/AppPages/Events/event";
import RadioList from "@/components/Select/RadioList.vue";
import EventStatisticsLine from "@/pages/Statistics/EventStatisticsLine";
import {EventStatisticsMixin} from "@/pages/Statistics/eventStatisticsMixin";
import {mapGetters} from "vuex";
import StatisticsTable from "@/pages/Statistics/StatisticsTable.vue";
import {getPalette} from "@/pages/Statistics/palette";
import OffscreenChart from "@/pages/Statistics/OffscreenChart.vue";
import {TableActions} from "@/store/tables/constants";

export default {
    name: "EventStatistics",
    components: {OffscreenChart, StatisticsTable, EventStatisticsLine, RadioList, SingleSelect, EventStatisticsBar},
    mixins: [EventStatisticsMixin],
    computed: {
        ...mapGetters(['isInController', 'isMunicipalController', 'isInContractor',
            'hasMunicipalityRestrictions', 'userOrganizationMunicipalities', 'isVetControl']),
        title() {
            return 'Проведенные мероприятия'
        }
    },
    methods: {
        canSelectContractor() {
            return this.isMunicipalController || this.isInController || this.isVetControl
        },
        canSelectMunicipality() {
            return this.isInController || this.hasMunicipalityRestrictions && this.userOrganizationMunicipalities.length > 1 || this.isVetControl
        },
        getExtraParams() {
            const palette = getPalette(8)
            return [
                { query: { 'kind': EventKind.CATCHING }, label: 'Отловленные животные', filterLabel: 'Отлов', borderColor: palette[0] },
                { query: { 'kind': EventKind.RETURN_TO_HABITAT }, label: 'Животные, выпущенные в прежнюю среду обитания', filterLabel: 'Возврат в прежнюю среду', borderColor: palette[1]},
                { query: { 'kind': EventKind.RETURN_TO_OWNER, 'owner_type': 1 }, label: ' Животные, возвращенные прежнему владельцу', filterLabel: 'Владелец', borderColor: palette[2]},
                { query: { 'kind': EventKind.RETURN_TO_OWNER, 'owner_type': 2 }, label: ' Животные, переданные новым владельцам', filterLabel: 'Новый владелец', borderColor: palette[3]},
                { query: { 'kind': EventKind.SURVEY, 'is_aggressive': true }, label: 'Животные, признанные агрессивными', filterLabel: 'Освидетельствование', borderColor: palette[4]},
                { query: { 'kind': EventKind.DEATH }, label: 'Умершие животные', filterLabel: 'Смерть', borderColor: palette[5]},
                { query: { 'kind': EventKind.TRANSFER, 'transfer_contract_type': 3 }, label: 'Животные, переданные в собственность ОМСУ', filterLabel: 'Передача между контрактами', borderColor: palette[6]},
                { query: { 'kind': EventKind.INITIAL, 'is_repeated_catching': true }, label: 'Повторно отловленные животные', filterLabel: 'Первичный осмотр', borderColor: palette[7]}
            ];
        },
        onTableValueClicked(value) {
            const rowParams = value.rowParams;
            console.log(rowParams)
            const colParams = value.colParams;
            let filters = [
                {'key': 'kind', 'value': rowParams['kind'], 'label': value.filterLabel}
            ]

            if (rowParams['owner_type']) {
                filters.push({'key': 'return_to_owner_type', 'value': rowParams['owner_type'], 'label': value.filterLabel, 'link': 'kind', 'linkValue': rowParams['kind']})
            }

            if (rowParams['is_aggressive']) {
                filters.push({'key': 'is_aggressive', 'value': rowParams['is_aggressive'], 'label': 'Агрессивно'})
            }

            if (rowParams['is_repeated_catching']) {
                filters.push({'key': 'is_repeated_catching', 'value': rowParams['is_repeated_catching'], 'label': 'Отловлено повторно'})
            }

            if (rowParams['transfer_contract_type']) {
                filters.push({'key': 'transfer_contract_type', 'value': rowParams['transfer_contract_type'],
                    'label': 'ОМСУ (животные в муниципальной собственности)', 'link': 'kind', 'linkValue': rowParams['kind']})
            }

            let dateStart = null;
            let dateEnd = null;
            if (rowParams['execution_month']) {
                const m = parseInt(rowParams['execution_month']);
                const y = parseInt(rowParams['execution_year'] ? rowParams['execution_year'] : new Date().getFullYear().toString());
                const newDate = new Date(y, m, 0)
                dateStart = `01.${m}.${y}`;
                dateEnd = `${newDate.getDate()}.${newDate.getMonth() + 1}.${y}`;
            } else if (rowParams['execution_year']) {
                dateStart = '01.01.' + rowParams['execution_year'];
                dateEnd = '31.12.' + rowParams['execution_year'];
            }
            if (rowParams['execution_date_from']) {
                dateStart = rowParams['execution_date_from']
            }
            if (rowParams['execution_date_to']) {
                dateEnd = rowParams['execution_date_to']
            }
            if (colParams && (colParams['date_start'] || colParams['date_end'])) {
                if (!rowParams['cumulative']) {
                    dateStart = colParams['date_start']
                }
                if (colParams['date_end']) {
                    dateEnd = colParams['date_end']
                }
            }
            if (dateStart) {
                filters.push({'key':'execution_date_from', 'value': dateStart, 'label': 'Дата проведения не ранее ' + dateStart})
            }
            if (dateEnd) {
                filters.push({'key': 'execution_date_to', 'value': dateEnd, 'label': 'Дата проведения не позднее ' + dateEnd})
            }

            if (colParams && colParams['municipality']) {
                filters.push({'key': 'municipality', 'value': colParams['municipality'], 'label': colParams['name']})
            } else {
                if (rowParams['municipality']) {
                    filters.push({'key': 'municipality', 'value': rowParams['municipality'], 'label': rowParams['municipality_name']})
                }
            }

            if (colParams && colParams['contractor']) {
                filters.push({'key': 'executor', 'value': colParams['contractor'], 'label': colParams['name']})
            } else {
                if (rowParams['executor']) {
                    filters.push({'key': 'executor', 'value': rowParams['executor'], 'label': rowParams['executor_name']})
                }
            }

            const tableName = 'common-events-table';
            this.$store.dispatch(TableActions.TABLE_SET_CURRENT_PAGE,
                { name: tableName, page: 1 })
                .then(() => {
                    return this.$store.dispatch(TableActions.TABLE_CHANGE_FILTERS,
                        { name: tableName, filterData: filters })
                })
                .then(() => {
                    window.open('/events', '_blank').focus();
                });
        },
        getOffscreenSubtitle() {
            let subtitle = '';
            const cumulative = Object.keys(this.commonQueryParams).length > 0 && this.commonQueryParams['cumulative'];
            if (cumulative) {
                subtitle += 'Нарастающим итогом '
            }

            let subtitleBreakdown = ''
            if (parseInt(this.breakdownType) === 1) {
                subtitleBreakdown = 'За '
            } else if (parseInt(this.breakdownType) === 2) {
                subtitleBreakdown = 'По муниципалитетам'
            } else if (parseInt(this.breakdownType) === 3) {
                subtitleBreakdown = 'По исполнителям'
            }

            if (cumulative) {
                subtitleBreakdown = subtitleBreakdown.toLowerCase()
            }

            subtitle += subtitleBreakdown

            if (Object.keys(this.commonQueryParams).length > 0 && parseInt(this.breakdownType) !== 1) {
                subtitle += '\n'
            }
            if (this.commonQueryParams['execution_month']) {
                let d = new Date()
                d.setMonth(this.commonQueryParams['execution_month'] - 1)
                subtitle += d.toLocaleString('ru-RU', { month: "long" }) + ', '
            }
            if (this.commonQueryParams['execution_year']) {
                subtitle += this.commonQueryParams['execution_year'] + ' г.'
            }
            if (this.commonQueryParams['execution_date_from'] && this.commonQueryParams['execution_date_to']) {
                subtitle += 'период c ' + this.commonQueryParams['execution_date_from'] + ' по ' + this.commonQueryParams['execution_date_to']
            }
            if (this.commonQueryParams['execution_date_from'] && !this.commonQueryParams['execution_date_to']) {
                subtitle += 'период c ' + this.commonQueryParams['execution_date_from'] + ' по н. вр.'
            }
            if (!this.commonQueryParams['execution_date_from'] && this.commonQueryParams['execution_date_to']) {
                subtitle += 'период c н. вр.' + this.commonQueryParams['execution_date_from'] + ' по ' + this.commonQueryParams['execution_date_to']
            }
            if (this.commonQueryParams['municipality_name']) {
                subtitle += ', ' + this.commonQueryParams['municipality_name']
            }
            if (this.commonQueryParams['executor_name']) {
                subtitle += ', ' + this.commonQueryParams['executor_name']
            }
            return subtitle
        }
    }
}
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s ease-out;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>